import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Executes record assignment through the record-owned plugin API.
 */
export const executeAssign = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.assign.request.observe().pipe(
      rxjs.mergeMap(action =>
        plugin.api.assign(action.data).pipe(
          rxjs.map(() =>
            feature.actions.assign.success.from(action).create({
              request: action.data,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.assign.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
